import { AnalyticsWasteProfileAdminStatusChangeData } from '../interfaces';

export class AnalyticsWasteProfileAdminStatusChangeDataModel
  implements AnalyticsWasteProfileAdminStatusChangeData {
  public static DEFAULT_CONFIG: AnalyticsWasteProfileAdminStatusChangeData = {
    customerName: '',
    profileNumber: '',
    wasteStreamName: '',
    dateStatusChanged: '',
    submittedBy: '',
    status: ''
  };
  readonly customerName: string;
  readonly profileNumber: string;
  readonly wasteStreamName: string;
  readonly dateStatusChanged: Date | string;
  readonly submittedBy: string;
  readonly status: string;
}
